import classNames from 'classnames';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockContent } from 'components/blocks/BlockContent';
import { NextLink } from 'components/blocks/NextLink';

import { ReactComponent as SvgMarker } from 'public/assets/icons/marker.svg';
import { useContactInformation } from 'util/useContactInformation';
import styles from './styles.module.scss';

export const ContactInformation = ({
  title,
  uuid,
}: {
  title: string,
  uuid: string,
}) => {
  const contactInfo = useContactInformation(uuid);

  const isLongTitle = title.length > 24;

  if (!contactInfo) return null;

  const { address: { city, country, postOffice }, email, phoneNumber } = contactInfo;

  return (
    <div className={styles.wrapBox}>
      <BoxWithShadow className={styles.bg_blue}>
        <BlockContent className={styles.box}>
          <div className={styles.innerLeft}>
            <div>
              <span className={classNames('h2', styles.title, isLongTitle && styles.longTitle)}>{title}</span>
              <div className={styles.address}>
                <SvgMarker height={24} width={18} />
                <div>
                  <p>{postOffice}</p>
                  <p>
                    {city}
                    {' '}
                    {country}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className={styles.phone}>
                <p>
                  <NextLink href={`tel:${phoneNumber}`}>
                    {phoneNumber}
                  </NextLink>
                </p>
              </div>
              <div className={styles.email}>
                <p>
                  <NextLink href={`mailto:${email}`}>
                    {email}
                  </NextLink>
                </p>
              </div>
            </div>
          </div>
        </BlockContent>
      </BoxWithShadow>
    </div>
  );
};
